<template>
  <div></div>
</template>
<script>
export default {
  name :"FooterPage",
  methods : {}
}
</script>